module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAAGCAYAAAAbmxqXAAAAVklEQVR4AWO4uqqB7fmuio5nO8vfgTCIDRJjwA2orocCfaPugwr+R8YgMTxmUV0PBfpG3QeKTXQJkBges+imh7C+UfcN8QAadd8QL6JG3TfEGwmj7gMAsjubGiUTX70AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/points.png
// module id = KrgT
// module chunks = 215